// Luca Siviero

document.addEventListener("DOMContentLoaded", () => {

    // Legge la lista ordinata dei variant id reali del prodotto
    function leggiVariantIdsOrdinati() {
        const el = document.querySelector('shopify-accelerated-checkout[variant-params]');
        if (!el) {
            console.warn('[VariantSync] Elemento shopify-accelerated-checkout con variant-params non trovato.');
            return null;
        }

        try {
            const raw = el.getAttribute('variant-params');
            const parsed = JSON.parse(raw);
            // Ogni entry è tipo { id: 54837344207116, requiresShipping: true }
            const ids = parsed.map(v => v.id);
            return ids;
        } catch (e) {
            console.error('[VariantSync] Errore nel parsing di variant-params:', e);
            return null;
        }
    }

    // Trova il vero form del prodotto (quello con action="/cart/add")
    function trovaFormProdotto() {
        return document.querySelector('form[action="/cart/add"]');
    }

    // Funzione condivisa: scrive il variant id corretto nel form, dato un
    // indice di posizione (0-based) e un'etichetta per il log.
    function aggiornaVarianteRealePerIndice(indice, etichetta) {
        const variantIds = leggiVariantIdsOrdinati();
        if (!variantIds) return false;

        if (indice < 0 || indice >= variantIds.length) {
            console.warn(`[VariantSync] Indice ${indice} fuori range (${variantIds.length} varianti trovate). Controlla che il numero di swatch/thumbnail e di varianti Shopify combaci.`);
            return false;
        }

        const nuovoVariantId = variantIds[indice];

        const form = trovaFormProdotto();
        if (!form) {
            console.error('[VariantSync] Form del prodotto (action="/cart/add") non trovato.');
            return false;
        }

        const inputId = form.querySelector('input[name="id"]');
        if (!inputId) {
            console.error('[VariantSync] input[name="id"] non trovato dentro il form.');
            return false;
        }

        const valorePrecedente = inputId.value;
        inputId.value = nuovoVariantId;
        inputId.dispatchEvent(new Event('change', { bubbles: true }));

        return true;
    }

    function trovaIndiceSwatch(radioSelezionato) {
        const container = radioSelezionato.closest('.swatch-container');
        if (!container) {
            console.warn('[VariantSync] Nessun .swatch-container trovato come antenato del radio.');
            return -1;
        }
        const tutteLeSwatch = Array.from(container.querySelectorAll('input[name="properties[Seleziona variante]"]'));
        return tutteLeSwatch.indexOf(radioSelezionato);
    }

    function aggiornaVarianteReale(radioSelezionato) {
        const indice = trovaIndiceSwatch(radioSelezionato);
        if (indice === -1) {
            console.warn('[VariantSync] Impossibile determinare la posizione della swatch selezionata.');
            return false;
        }
        return aggiornaVarianteRealePerIndice(indice, `colore: "${radioSelezionato.value}", posizione ${indice}`);
    }

    // Osserviamo la comparsa dei radio "Seleziona variante" di Customily
    // (il modal è generato dinamicamente, quindi non è detto sia già nel DOM)
    const observer = new MutationObserver(() => {
        const radios = document.querySelectorAll('input[name="properties[Seleziona variante]"]');
        radios.forEach((radio) => {
            if (radio.dataset._variantSyncBound) return;
            radio.dataset._variantSyncBound = "true";

            radio.addEventListener('change', () => {
                if (!radio.checked) return;
                aggiornaVarianteReale(radio);
            });
        });

        // Se al momento del binding c'è già un radio selezionato (es. default),
        // sincronizziamo subito.
        const giaSelezionato = document.querySelector('input[name="properties[Seleziona variante]"]:checked');
        if (giaSelezionato) {
            aggiornaVarianteReale(giaSelezionato);
        }

        // --- CASO SEPARATO: click diretto sui thumbnail, senza passare da Customily ---
        // Il cliente può scegliere il colore semplicemente cliccando la foto,
        // senza mai aprire il modal Customily. In quel flusso i radio sopra
        // non esistono/non cambiano mai, quindi va gestito come binding a parte,
        // usando la stessa fonte di variant id (variant-params) ma indicizzando
        // per posizione del thumbnail invece che per indice della swatch.
        const thumbnails = document.querySelectorAll('.product-gallery__thumbnail');
        thumbnails.forEach((thumb, indice) => {
            if (thumb.dataset._variantSyncBound) return;
            thumb.dataset._variantSyncBound = "true";

            thumb.addEventListener('click', () => {
                aggiornaVarianteRealePerIndice(indice, `thumbnail posizione ${indice}`);
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});